import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { Grid, Header, Image, Menu } from 'semantic-ui-react'
import back from '../../../assets/svg/back_arrow.svg'
import { RootState } from '../../../store/rootState'
import { IRouteParams } from '../../../types/routeParams'
import * as AccountingActions from '../../project/actions/accountingActions'
import * as ProjectActions from '../../project/actions/projectActions'
import { IProject } from '../../project/types/project'
import { _initialProject } from '../../../fixtures/projectFixtures'
import * as GlobalAccountingActions from '../actions/accountingActions'


interface StateProps {
  project: IProject
  selectedTab: string
}

interface DispatchProps {
  getProject: (id: string | number, queryParams?: Record<string, string>) =>  Promise<IProject>
  selectTab: (tab: string) => void
  selectProject: (project: IProject) => void
  setPaginatedInvoicesActivePage: (page: number) => void
  selectAccountingTab: (tab: string) => void
}

const _ACCOUNTING_TABS = [
  { name: 'Income', key: 'receipts' },
  { name: 'Expenses', key: 'expenses' },
  { name: 'Pass-Through-Costs', key: 'pass-through-costs' }
]

type Props = StateProps & DispatchProps

const AccountingHeaderContainer = (props: Props): JSX.Element => {

  const { project, getProject, selectedTab, selectTab, selectProject, setPaginatedInvoicesActivePage, selectAccountingTab } = props

  const _location = useLocation()
  const _history = useHistory()
  const params = useParams() as IRouteParams

  useEffect(() => {
    if (params.id) {
      getProject(params.id, { module: 'accounting' })
    }
  }, [params.id, getProject])

  useEffect(() => {
    if (!_location.pathname.split('/').includes('projects')) {
      selectAccountingTab('')
    }
  }, [_location.pathname, selectAccountingTab])

  useEffect(() => {
    if (selectedTab === '') {
      selectTab(_ACCOUNTING_TABS[0].key)
    }
  }, [selectedTab, selectTab])

  const handleGoBack = () => {
    if (`/accounting/${project.id}` === _location.pathname) {
      _history.replace('/accounting'.split('/').filter(path => path !== '')[0].replace(/^/, '/'))
    }
  }

  const handleItemClick = (key: string) => {
    if (key !== selectedTab) {
      setPaginatedInvoicesActivePage(1)
      selectTab(key)
      // _initialProject, never `{} as IProject`: that cast leaves financial_calculation
      // undefined, which the accounting selectors dereference (issue #20 review, claim 2).
      selectProject(_initialProject)
      _history.replace('/accounting')
    }
  }

  const subRouteNav = () => {
    if (`/accounting/${project.id}` === _location.pathname) {
      return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Header.Content style={{ marginLeft: '.5rem', color: '#08D6A1' }}>/</Header.Content>
          <Header.Content style={{ marginLeft: '.5rem', color: '#08D6A1' }}>{project.name}</Header.Content>
        </div>
      )
    }
    return null
  }

  return (
    <Grid columns={2} style={{ margin: 0 }}>
      <Grid.Row stretched style={{ paddingBottom: 0 }}>
        <Grid.Column style={{ alignItems: 'start' }}>
          <Header>
            <Header.Content style={{ textAlign: 'start', display: 'flex', alignItems: 'flex-start', color: '#232C58', fontSize: '2.25rem', letterSpacing: '.25px', marginLeft: '-16px', marginTop: '-14px' }}>
              <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={handleGoBack}>
                {_location.pathname !== '/accounting' ? <Image src={back} style={{ width: '1.2rem', height: '1.2rem', marginRight: '0.3rem' }}/> : null}
                Accounting
              </div>
              {subRouteNav()}
            </Header.Content>
          </Header>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row style={{ padding: 0 }}>
        <Menu pointing secondary style={{ marginBottom: '10px', width: '100%' }}>
          {_ACCOUNTING_TABS.map(tab => {
            return (
              <Menu.Item
                style={{
                  padding: '30px 40px 16px 40px',
                  fontSize: '1.45rem',
                  display: 'flex',
                  justifyContent: 'center'
                }}
                key={tab.key}
                name={tab.name}
                active={selectedTab === tab.key}
                onClick={() => handleItemClick(tab.key)}
              />
            )
          })}
        </Menu>
      </Grid.Row>
  </Grid>
  )
}

const mapStateToProps = (state: RootState): StateProps => {
  return {
    project: state.projectsState.project,
    selectedTab: state.accountingState.selectedTab
  }
}

const mapDispatchToProps = (dispatch: ProjectActions.ProjectThunkDispatchType
  & GlobalAccountingActions.GlobalAccountingThunkDispatchType
  & AccountingActions.AccountingThunkDispatchType): DispatchProps => {
  return {
    setPaginatedInvoicesActivePage: activePage => dispatch(GlobalAccountingActions.setPaginatedInvoicesActivePage(activePage)),
    getProject: (id, params) => dispatch(ProjectActions.getProject(id, params)),
    selectTab: tab => dispatch(GlobalAccountingActions.selectTab(tab)),
    selectProject: project => dispatch(ProjectActions.selectProject(project)),
    selectAccountingTab: tab => dispatch(AccountingActions.selectAccountingTab(tab)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountingHeaderContainer)
